import { all, takeEvery, call, put } from 'redux-saga/effects';
import actions from './actions';
import SuperFetch from '../../helpers/superFetch';
import { apiUrls, getaddressConfig } from '../../settings';

const getUserInfo = async () =>
    await SuperFetch.post(apiUrls.getUserProfile)
        .then(res => res)
        .catch(error => ({ error: JSON.stringify(error) }));

const getUserAddressBook = async () =>
    await SuperFetch.post(`${apiUrls.getLandlordAddressBook}V2`)
        .then(res => res)
        .catch(error => ({ error: JSON.stringify(error) }));

const getLandlordAddress = async () =>
    await SuperFetch.post(`${apiUrls.getLandlordAddress}`)
        .then(res => res)
        .catch(error => ({ error: JSON.stringify(error) }));

function* getUserData() {
    const userInfo = yield call(getUserInfo);
    const addressBook = yield call(getUserAddressBook);
    const addresses = yield call(getLandlordAddress);
    const userData = {
        extended: userInfo.extended,
        user: userInfo.user,
        llData: userInfo.llData,
        addressbook: addressBook.landlordAddressBook,
        addresses: addresses,
        hasSubs: userInfo.hasSubs,
        subs: userInfo.subs,
        landlordOrganisation: userInfo.landlordOrganisation,
    };
    window.hj('tagRecording', [`userId-${userInfo.user.id}`]);
    yield [
        put(actions.setUserData(userData))
    ];
}

const doUpdateExtendedProfile = async payload => {
    const body = {
        data: payload
    }
    return await SuperFetch.post(apiUrls.updateExtendedProfile, body)
        .then(res => res)
        .catch(error => ({ error: JSON.stringify(error) }));
}

function* updateExtendedProfile(action) {
    const response = yield call(doUpdateExtendedProfile, action.payload);
    if (response) {
        yield put(actions.updateExtendedProfileSuccess(response));
    } else {
        yield put(actions.updateExtendedProfileFailed(response));
    }
}

const doUpdatePassword = async payload => {
    const body = {
        data: payload
    }
    return await SuperFetch.post(apiUrls.changePassword, body)
        .then(res => res)
        .catch(error => ({ error: JSON.stringify(error) }));
}

function* updatePassword(action) {
    const response = yield call(doUpdatePassword, action.payload);
    if (response && response.success) {
        yield put(actions.updatePasswordSuccess(response));
    } else {
        yield put(actions.updatePasswordFailed(response));
    }
}

const doPostcodeLookup = async payload => {
    return fetch(`${getaddressConfig.API_URL}${payload}?api-key=${getaddressConfig.API_KEY}&sort=true`)
        .then((response) => response.json())
        .then((data) => data)
        .catch(error => ({
            error: JSON.stringify(error)
        }));
};

function* postCodeLookup(payload) {
    const postCodeResult = yield call(doPostcodeLookup, payload.payload.postCode);
    if (postCodeResult && postCodeResult.addresses && postCodeResult.addresses.length) {
        if(payload.payload.type === "billing") {
            yield put({
                type: actions.ON_BILLING_POSTCODE_LOOKUP,
                payload: postCodeResult
            });
        } else {
            yield put({
                type: actions.ON_CONTACT_POSTCODE_LOOKUP,
                payload: postCodeResult
            });
        }
    } else {
        yield put(
            actions.doPostcodeLookupFailed(postCodeResult)
        );
    }
}

const doUpdateAddress = async payload => {
    const body = {
        data: payload
    }
    return await SuperFetch.post(apiUrls.setLandlordAddress, body)
        .then(res => res)
        .catch(error => ({ error: JSON.stringify(error) }));
}

function* updateAddress(action) {
    const response = yield call(doUpdateAddress, action.payload);
    if (response && response.address.address1 === action.payload.address1) {
        yield put(actions.onAddressSaved());
        yield put(actions.getUserData());
    }
}

export default function* rootSaga() {
    yield all([
        takeEvery(actions.GET_USER_DATA, getUserData),
        takeEvery(actions.UPDATE_EXTENDED_PROFILE, updateExtendedProfile),
        takeEvery(actions.UPDATE_PASSWORD, updatePassword),
        takeEvery(actions.BILLING_POSTCODE_LOOKUP, postCodeLookup),
        takeEvery(actions.CONTACT_POSTCODE_LOOKUP, postCodeLookup),
        takeEvery(actions.ON_UPDATE_ADDRESS, updateAddress),
    ]);
}


// WEBPACK FOOTER //
// ./src/redux/app/sagas.js